// @ts-nocheck
const isConfigurableProperty = (obj, field) => {
  const desc = Object.getOwnPropertyDescriptor(obj, field);
  return desc && desc.configurable;
};

export default isConfigurableProperty;
